<template>
  <v-card class="rounded-lg" flat>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" class="pa-0">
          <v-card-item
            :prepend-icon="'mdi-briefcase-check-outline'"
            class="py-2"
          >
            <template v-slot:prepend>
              <v-icon style="margin-right: 10px" />
            </template>

            <h5 class="font-weight-regular">{{ $t('investments.info.totalAmount') }}</h5>
            <span class="text-h6 font-weight-medium">
              {{ $formatNumber(amountOfInvestment) }} {{ currency }}
            </span>
          </v-card-item>
        </v-col>

        <v-col cols="12" sm="6" class="pa-0">
          <v-card-item
            :prepend-icon="'mdi-calendar-month-outline'"
            class="py-2"
          >
            <template v-slot:prepend>
              <v-icon style="margin-right: 5px" />
            </template>

            <h5 class="font-weight-regular">{{ $t('investments.info.nextPayment') }}</h5>
            <span class="text-h6 font-weight-medium">
              {{ $formatNumber(nextPayment) }} {{ currency }}
            </span>
          </v-card-item>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: [
    "nextPayment",
    "amountOfInvestment",
    "currency",
    "investments"
  ],
}
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .card-text {
    font-size: 14px !important;
  }
}
</style>
